import { CommonModule } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { NavigationBackService } from '@core/services/navigation-back/navigation-back.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [CommonModule, NgbModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    // Eager: NavigationBackService records the in-app URL stack from app start.
    provideAppInitializer(() => {
      inject(NavigationBackService);
    }),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. You should only import Core modules in the AppModule only.',
      );
    }
  }
}
